/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsCancelSerialNumber
 */
export interface IdentityMelcoModelsCancelSerialNumber {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsCancelSerialNumber
     */
    comments?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsCancelSerialNumber
     */
    sub_cancelled_date?: Date | null;
}

export function IdentityMelcoModelsCancelSerialNumberFromJSON(json: any): IdentityMelcoModelsCancelSerialNumber {
    return IdentityMelcoModelsCancelSerialNumberFromJSONTyped(json, false);
}

export function IdentityMelcoModelsCancelSerialNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsCancelSerialNumber {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'sub_cancelled_date': !exists(json, 'sub_cancelled_date') ? undefined : (json['sub_cancelled_date'] === null ? null : new Date(json['sub_cancelled_date'])),
    };
}

export function IdentityMelcoModelsCancelSerialNumberToJSON(value?: IdentityMelcoModelsCancelSerialNumber | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comments': value.comments,
        'sub_cancelled_date': value.sub_cancelled_date === undefined ? undefined : (value.sub_cancelled_date === null ? null : value.sub_cancelled_date.toISOString()),
    };
}


